import { render, staticRenderFns } from "./DonateForm.vue?vue&type=template&id=2d3382cb&"
import script from "./DonateForm.vue?vue&type=script&lang=js&"
export * from "./DonateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports